import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';
import { Drawer, PrimaryButton } from '@common/components';
import { OfferForm } from 'works/components/offer-form';
import { OfferInfoSummary, OfferInfoHeader } from '@applicant-flow/components';
import { MakeOfferDrawerFooter } from './make-offer-drawer-footer';
import { getRateByEmploymentType } from '@institutions/services';

export function MakeOfferDrawerWithButton({
  application,
  children,
  type = 'primary',
}) {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { staffingRequest } = application;
  const billingCardRate = getRateByEmploymentType(
    staffingRequest.billingCard,
    staffingRequest.shiftType,
    application.employmentType
  );
  const initialRate = billingCardRate || staffingRequest.billingRegularRate;
  const [currentRate, setCurrentRate] = useState(initialRate);
  const [isFormValid, setIsFormValid] = useState(true);

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <PrimaryButton onClick={() => setOpen(true)} type={type}>
        {children}
      </PrimaryButton>

      <Drawer
        title="Offer Letter"
        open={open}
        onClose={onClose}
        footer={
          <MakeOfferDrawerFooter
            onCancel={onClose}
            onSubmit={form.submit}
            loading={loading}
            disabled={!isFormValid}
          />
        }
      >
        <OfferInfoHeader
          candidateFullName={application.worksProfile.fullName}
          doNotRehire={application.doNotRehire}
        />
        <OfferInfoSummary
          application={application}
          rate={currentRate?.toFixed(2)}
          oldRate={initialRate.toFixed(2)}
        />
        <OfferForm
          form={form}
          application={application}
          onRateChange={setCurrentRate}
          onFinish={onClose}
          onLoading={setLoading}
          setIsFormValid={setIsFormValid}
          initialRate={initialRate}
        />
      </Drawer>
    </>
  );
}

MakeOfferDrawerWithButton.propTypes = {
  application: PropTypes.shape({
    id: PropTypes.string.isRequired,
    doNotRehire: PropTypes.bool.isRequired,
    employmentType: PropTypes.string.isRequired,
    worksProfile: PropTypes.shape({
      id: PropTypes.string.isRequired,
      fullName: PropTypes.string.isRequired,
    }),
    staffingRequest: PropTypes.shape({
      id: PropTypes.string.isRequired,
      shiftType: PropTypes.string.isRequired,
      billingRegularRate: PropTypes.string.isRequired,
      billingCard: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }),
    }),
    canIncreaseOfferRate: PropTypes.shape({
      value: PropTypes.bool.isRequired,
    }),
  }),
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
};
